import axios from "axios";
import React, { useEffect, useState } from "react";
import Spinner from "../../../../../../../Assets/Images/EclipseSpinner.svg";
import { Config } from "../../../../../../../Config";

const SkillFinder = (props) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [ResultIsOpen, setResIsOpen] = useState(false);
  const [PlaceHolderIsShown, setPlaceHolderIsShown] = useState(true);
  const [Skills, setSkills] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [ResultIsEmpty, setResIsEmpty] = useState(false);
  const [InsufficientChars, setInsufficientChars] = useState(false);
  const [SkillsToAdd, setSkillsToAdd] = useState(5);
  const [ClearButtonShown, setClearButtonShown] = useState(false);

  useEffect(() => {
    setSelectedSkills(props.PreselectedSkills);
    setSkillsToAdd(5 - props.PreselectedSkills.length);
  }, [props.PreselectedSkills]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const searchSkills = () => {
    let Keyword = document.getElementById("skill-input").value;
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/skill/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 50,
        start: 0,
        criteria: {
          titleLike: Keyword,
        },
        sorts: [
          {
            direction: "ASC",
            fieldName: "title",
          },
        ],
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSkills(Res.data.results);
        setIsLoading(false);
        if (Res.data.results.length === 0) {
          setResIsOpen(true);
          setResIsEmpty(true);
        } else if (document.getElementById("skill-input").value.length > 0) {
          // to prevent the result section from opening with no searched keyword after clearing the value
          setResIsOpen(true);
          setResIsEmpty(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  var ChangeTimer;
  const triggerChange = () => {
    let Skill = document.getElementById("skill-input").value;

    // handling displaying of the clear button
    if (Skill.length > 0) {
      setClearButtonShown(true);
    } else {
      setClearButtonShown(false);
    }

    clearTimeout(ChangeTimer);
    ChangeTimer = setTimeout(handleInputChange, 1500);
    if (Skill.length > 0) {
      setPlaceHolderIsShown(false);
      if (Skill.length > 2) {
        setResIsOpen(true);
        setIsLoading(true);
      } else {
        setResIsOpen(false);
      }
    } else {
      setPlaceHolderIsShown(true);
      setIsLoading(false);
      setResIsOpen(false);
      setSkills([]);
    }
    if (Skill.length > 0 && Skill.length < 3) {
      setInsufficientChars(true);
    } else {
      setInsufficientChars(false);
    }
  };
  const handleInputChange = () => {
    props.ChangeEvent();
    let Skill = document.getElementById("skill-input").value;
    if (Skill.length > 0) {
      if (Skill.length > 2) {
        searchSkills();
      }
    } else {
      setSkills([]);
    }
  };
  const handleClick = () => {
    setSelectedSkills(props.PreselectedSkills);
    if (document.getElementById("skill-input").value.length > 0) {
      setResIsOpen(true);
    } else {
      setResIsOpen(false);
    }
  };

  const selectSkill = (Skill) => {
    if (SkillsToAdd === 0) {
      const popupText = document.getElementById('popup-text')
      setTimeout(() => {
        popupText.style.display = 'none'
      }, 3000)
      popupText.style.display = 'block'
    }
    let SelectedSkillIds = [];
    SelectedSkills.map((Item) => {
      SelectedSkillIds.push(Item.id);
    });
    if (SelectedSkillIds.indexOf(Skill.id) === -1) {
      props.ChangeEvent();
      if (SelectedSkills.length < 5) {
        let PrevSkills = [...Skills];
        let PrevSelectedSkills = [...SelectedSkills];
        if (PrevSelectedSkills.length >= 4) {
          props.AllSelected();
        }
        PrevSkills.splice(PrevSkills.indexOf(Skill), 1);
        setSkills(PrevSkills);
        PrevSelectedSkills.push(Skill);
        setSelectedSkills(PrevSelectedSkills);
        props.SaveSkills(PrevSelectedSkills);
        setSkillsToAdd(SkillsToAdd - 1);
      } else {
        props.SaveSkills(SelectedSkills);
        return null;
      }
    }
  };
  const removeSkill = (Skill) => {
    props.ChangeEvent();
    let PrevSkills = [...Skills];
    let PrevSelectedSkills = [...SelectedSkills];
    PrevSkills.push(Skill);
    setSkills(PrevSkills);
    PrevSelectedSkills.splice(PrevSelectedSkills.indexOf(Skill), 1);
    setSelectedSkills(PrevSelectedSkills);
    setSkillsToAdd(SkillsToAdd + 1);
    if (PrevSelectedSkills.length < 6) {
      props.NotAllSelected();
    }
  };
  const toggleModal = () => {
    setPlaceHolderIsShown(true);
    setIsOpen(true);
    setTimeout(() => {
      document.getElementById("skill-input").click();
      document.getElementById("skill-input").focus();
    }, 300);
  };
  const toggleCloseModal = (IsSave) => {
    if (!IsSave) {
      setSelectedSkills(props.UserInfo.skills);
      setSkillsToAdd(0);
    }
    document.getElementById("skill-input").value = "";
    setResIsOpen(false);
    setIsOpen(false);
  };

  const clearInput = () => {
    document.getElementById("skill-input").value = "";
    setPlaceHolderIsShown(true);
    setClearButtonShown(false);
    setResIsOpen(false);
  };

  return (
    <React.Fragment>
      {IsOpen ? (
        <div className="overlay">
          {IsOpen ? (
            <div className="outline" onClick={() => toggleCloseModal()}></div>
          ) : null}
          <div className="skill-finder-modal">
            <section className="modal-head">
              <h1>{translateText("top_5_skills")}</h1>
              <i className="feather-x" onClick={() => toggleCloseModal()}></i>
            </section>
            <div className="skill-finder-wrapper skill-finder-wrapper-in-modal">
              <h1 className="modal-title">
                {translateText("wizard_select_top5_skills")} <p>*</p>
              </h1>
              {SelectedSkills.length < 5 ? (
                <p className="remaining-items">
                  {5 - SelectedSkills.length + " " + translateText("left")}
                </p>
              ) : (
                <p className="done-label">
                  {" "}
                  <i className="feather-check-circle"></i>
                </p>
              )}
              <section className="skill-finder-input">
                <p className='popup-text' id="popup-text">{translateText('max_skill_preference_reached')}</p>
                <i
                  className="feather-search"
                  onClick={() => toggleCloseModal()}
                ></i>
                <input
                  onChange={() => triggerChange()}
                  className="skill-text-input"
                  type="text"
                  id="skill-input"
                  autoComplete="off"
                />
                {PlaceHolderIsShown ? (
                  <p className="input-placeholder">{props.PlaceHolder}</p>
                ) : null}
                {ClearButtonShown ? (
                  <i
                    className="feather-x-circle"
                    onClick={() => clearInput()}
                  ></i>
                ) : null}
              </section>
              {ResultIsOpen ? (
                <React.Fragment>
                  {IsLoading ? (
                    <div className="results">
                      <img className="loading-spinner" alt="" src={Spinner} />
                    </div>
                  ) : (
                    <React.Fragment>
                      {ResultIsEmpty ? (
                        <div className="results">
                          <p className="empty-state">
                            {translateText("no_results_found")}
                          </p>
                        </div>
                      ) : (
                        <div className="results">
                          {Skills.map((Skill, i) => (
                            <React.Fragment key={i}>
                              {Skill.title.length > 0 ? (
                                <span
                                  className="skill-chip"
                                  onClick={() => selectSkill(Skill)}
                                >
                                  {Skill.title}
                                </span>
                              ) : null}
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {InsufficientChars ? (
                    <div className="results">
                      <p className="empty-state">
                        {translateText("enter_3_characters_at_least")}
                      </p>
                    </div>
                  ) : null}
                </React.Fragment>
              )}
            </div>
            {SelectedSkills.length > 0 ? (
              <div className="selected-skills">
                {SelectedSkills.map((Skill, i) => (
                  <div key={i}>
                    {Skill.title}
                    <i
                      className="feather-x"
                      onClick={() => removeSkill(Skill)}
                    ></i>
                  </div>
                ))}
              </div>
            ) : null}
            <section className="btn-group">
              <button
                className="modal-cancel"
                onClick={() => toggleCloseModal()}
              >
                Cancel
              </button>
              <button
                onClick={() => toggleCloseModal(true)}
                className={
                  SkillsToAdd > 0
                    ? "modal-action disabled-action"
                    : "modal-action"
                }
              >
                {SkillsToAdd === 0
                  ? translateText("done")
                  : SkillsToAdd + " " + translateText("left")}
              </button>
            </section>
          </div>
        </div>
      ) : (
        <React.Fragment>
          <div className="skill-finder-wrapper">
            {SelectedSkills.length < 5 ? (
              <p className="remaining-items">
                {5 - SelectedSkills.length + " " + translateText("left")}
              </p>
            ) : null}
            <section className="skill-finder-input">
              <i className="feather-search"></i>
              <span
                className="modal-trigger"
                onClick={() => toggleModal()}
              ></span>
              <p className="input-placeholder">{props.PlaceHolder}</p>
            </section>
          </div>
          {SelectedSkills.length > 0 ? (
            <div className="selected-skills">
              {SelectedSkills.map((Skill, i) => (
                <div key={i}>{Skill.title}</div>
              ))}
            </div>
          ) : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default SkillFinder;
